<template>
    <div :class="{'pos-absolute' : !isMobile}">
        <div v-if="!isMobile">
            <div class="triangle" :class="triangleClass"></div>
            <span class="label label-primary" v-html="label"></span>
        </div>
        <div class="special-tags p-2" v-if="isMobile && (hasLabel || isBundle || isSet)">
            <span v-if="hasLabel" class="badge" :class="tagClass" v-html="label">
            </span>
                <span v-else-if="isBundle" :class="tagClasses.itemBundle">
                {{ $translate("Ceres::Template.itemBundle") }}
            </span>
                <span v-else-if="isSet" :class="tagClasses.itemSet">
                {{ $translate("Ceres::Template.itemSet") }}
            </span>
        </div>
    </div>
</template>

<script>
import { isNullOrUndefined, isDefined } from "ceres/app/helper/utils";

export default {

    name: "item-store-special",

    props: [
        "storeSpecial",
        "recommendedRetailPrice",
        "variationRetailPrice",
        "specialOfferPrice",
        "decimalCount",
        "bundleType",
        "itemType"
    ],

    data()
    {
        return {
            tagClass: "",
            label: "",
            tagClasses:
            {
                1: "badge-offer badge-danger",
                2: "badge-new badge-primary",
                3: "badge-top badge-success",
                default: "badge-success",
                itemBundle: "badge badge-bundle bg-info",
                itemSet: "badge badge-dark"
            },
            labels:
            {
                1: this.$translate("Ceres::Template.storeSpecialOffer"),
                2: this.$translate("Ceres::Template.storeSpecialNew"),
                3: this.$translate("Ceres::Template.storeSpecialTop")
            },
            isMobile: false
        };
    },

    created()
    {
        this.initializeStoreSpecial();
    },

    mounted(){
        this.isMobile = window.innerWidth < 768;
    },

    computed:{

        hasLabel() {
            return this.label && this.label !== "";
        },

        isBundle() {
            return this.bundleType === "bundle";
        },

        isSet() {
            return this.itemType === "set";
        },

        triangleClass(){
            let className = "";
            switch(this.tagClass){
                case "badge-new badge-primary":
                    className = "triangle-primary"
                    break;

                case "badge-offer badge-danger":
                    className = "triangle-danger"
                    break;

                case "badge-top badge-success":
                    className = "triangle-success"
                    break;
            }

            return className;
        }
    },

    methods:
    {
        initializeStoreSpecial()
        {
            if (!isNullOrUndefined(this.storeSpecial))
            {
                this.tagClass = this.tagClasses[this.storeSpecial.id] || this.tagClasses.default;
            }
            else
            {
                this.tagClass = this.tagClasses.default;
            }

            this.label = this.getLabel();
        },

        getLabel()
        {
            if (!isNullOrUndefined(this.storeSpecial) && this.storeSpecial.id === 1 && !isNullOrUndefined(this.recommendedRetailPrice))
            {
                return "SALE<br/>"+ this.getPercentageSale();//this.getPercentageSale();
            }

            if (isNullOrUndefined(this.storeSpecial))
            {
                return "";
            }

            return this.labels[this.storeSpecial.id] || this.storeSpecial.names.name;
        },

        getPercentageSale()
        {
            let percent;

            if (isDefined(this.specialOfferPrice))
            {
                percent = (1 - this.specialOfferPrice.unitPrice.value / this.variationRetailPrice.unitPrice.value ) * -100;
            }
            else
            {
                percent = (1 - this.variationRetailPrice.unitPrice.value / this.recommendedRetailPrice.unitPrice.value ) * -100;
            }

            if (percent < 0)
            {
                return percent.toFixed(this.decimalCount).replace(".", App.decimalSeparator) + "%";
            }

            return "";
        }
    },

    watch:
    {
        storeSpecial()
        {
            this.initializeStoreSpecial();
        }
    }
}
</script>
